import { createAction, createReducer } from '@reduxjs/toolkit';
import { ConfigurationsState } from './configurationsTypes';
import { Configuration } from '../../types/rest/configurationsType';

export const setIsLoadingConfigurations = createAction<boolean>('SET_IS_LOADING_CONFIGURATIONS');

export const setIsBulkDeleting = createAction<boolean>('SET_IS_BULK_DELETING_CONFIGURATIONS');

export const setExpandedConfiguration = createAction<number | null>('SET_EXPANDED_CONFIGURATION');

export const updateConfigurationsList = createAction<Configuration[] | null>('UPDATE_CONFIGURATIONS');

export const setIsCreatingConfiguration = createAction<boolean>('SET_IS_CREATING_CONFIGURATION');

export const setIsRecentlySaved = createAction<boolean>('SET_IS_RECENTLY_SAVED');

export const setCurrentConfiguration = createAction<Configuration>('SET_IS_CURRENT_CONFIGURATION');

export class EmptyConfiguration implements Configuration {
  id = -1;
  name = '';
  description = '';
  configurationMap = {};
}

const initialState: ConfigurationsState = {
  configurations: [],
  isLoading: false,
  expandedId: null,
  pagination: {
    activePage: 1,
    pageSize: 10,
    totalResults: 0,
  },
  isCreatingNewConfiguration: false,
  currentConfiguration: {} as Configuration,
  newConfiguration: new EmptyConfiguration(),
  isRecentlySaved: false,
  isBulkDeleting: false,
};

export const configurationsReducer = createReducer(initialState, builder => {
  builder.addCase(setIsLoadingConfigurations, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(setExpandedConfiguration, (state, action) => {
    state.expandedId = action.payload;
  });

  builder.addCase(updateConfigurationsList, (state, action) => {
    state.configurations = action.payload;
  });

  builder.addCase(setIsRecentlySaved, (state, action) => {
    state.isRecentlySaved = action.payload;
  });

  builder.addCase(setIsCreatingConfiguration, (state, action) => {
    state.isCreatingNewConfiguration = action.payload;
    state.newConfiguration = new EmptyConfiguration();
    state.expandedId = -1;
  });

  builder.addCase(setCurrentConfiguration, (state, action) => {
    state.currentConfiguration = action.payload;
    if (action.payload && action.payload.id === -1) {
      state.newConfiguration = action.payload;
    }
  });

  builder.addCase(setIsBulkDeleting, (state, action) => {
    state.isBulkDeleting = action.payload;
  });
});
